// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Config } from "../config";
import { SystemSetting, SystemSettingRequest } from "./types/accessSettingsTypes";

const apiManagementRootUrl: string | undefined = Config.REACT_APP_CCL_API_MANAGEMENT_URL;

// Define a service using a base URL and expected endpoints
export const cclTokenedSettingsApi = createApi({
    reducerPath: "cclTokenedSettingsApi",
    tagTypes: ["AppUrls", "SystemSettings"],
    baseQuery: fetchBaseQuery({
        baseUrl: apiManagementRootUrl,
        prepareHeaders: (headers, { getState }) => {
            //we should probably change this.
            const token = localStorage.getItem("token") as string;
            headers.set("authorization", `Bearer ${token}`);
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getAppUrls: builder.query<any, void>({
            query: () => `ccl-access2-data/v1.0/Settings/app-urls`,
            providesTags: ["AppUrls"],
        }),
        getAppSetting: builder.query<SystemSetting, string>({
            query: (settingTag) => `ccl-access2-data/v1.0/Settings/${settingTag}`,
            providesTags: (_, __, settingTag) => [{ type: "SystemSettings", id: settingTag }],
        }),
        saveAppSetting: builder.mutation<SystemSetting, SystemSettingRequest>({
            query: (request) => ({
                url: `ccl-access2-data/v1.0/Settings/${request.tag}`,
                method: "POST",
                body: request.setting,
            }),
            invalidatesTags: (_, __, request: SystemSettingRequest) => [
                { type: "SystemSettings", id: request.tag },
            ],
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetAppUrlsQuery, useGetAppSettingQuery, useSaveAppSettingMutation } =
    cclTokenedSettingsApi;
